import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import {
  CircularProgress,
  Box,
} from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    backgroundColor: '#fff'  
  },
  linear:{
    height: '6px'
  },
  loader: {
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  central:{
    textAlign: 'center'
  }
}))
function Loading({noData}) {
  const classes = useStyles()
  return (
    <>
    <div className={classes.root}>
      <Box className={classes.loader}>
        <Box className={classes.central}>
          {!noData ? <CircularProgress thickness={5} color="secondary"/> : "No Such Data. Please update the Filter" } 
        </Box>
      </Box>
    </div>
    </>
  )
}

export default Loading;
